import type { WorkoutSortOption } from '../../../../WorkoutTemplates/types';

export function getOrdering(sortOption: WorkoutSortOption, ascending: boolean): string {
  if (sortOption === 'name') {
    return ascending ? 'name,-date' : '-name,-date';
  }

  if (sortOption === 'classType') {
    return ascending ? 'kilo_class_type__name,-date' : '-kilo_class_type__name,-date';
  }

  return '-date';
}
